var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loaded)?_c('business-trip-request-expense-form',{attrs:{"refreshable":"","editable":_vm.editable},on:{"input":_vm.change,"refresh":_vm.refresh,"save":_vm.save,"close":_vm.close},model:{value:(_vm.expense),callback:function ($$v) {_vm.expense=$$v},expression:"expense"}}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f4915ff","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/business-trip/BusinessTripRequestExpenseDetail.vue
// module id = null
// module chunks = 